import React, { useState } from "react";
import { Row, Col, Card, DatePicker, Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import moment from "moment";
import { downloadActivityReport } from "../redux/adminSlice";

const { RangePicker } = DatePicker;

export default function DownloadActivityReport() {
  const dispatch = useDispatch();
  const [dateRange, setDateRange] = useState(null);
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const startDate = dateRange?.[0] ? dateRange[0].format("YYYY-MM-DD") : undefined;
      const endDate = dateRange?.[1] ? dateRange[1].format("YYYY-MM-DD") : undefined;

      const response = await dispatch(downloadActivityReport({ startDate, endDate })).unwrap();
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const label = startDate && endDate ? `${startDate}_to_${endDate}` : moment().format("YYYY-MM");
      link.setAttribute("download", `activity-report_${label}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      message.success("Report downloaded.");
    } catch (error) {
      message.error("Failed to download report.");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Row gutter={16} style={{ padding: "0 5%" }}>
      <Col xs={24} md={24} style={{ paddingBottom: 16 }}>
        <p style={{ color: "#335CAD", fontWeight: "bold", fontSize: 16 }}>
          Download Activity Report
        </p>

        <Card>
          <p style={{ color: "#595959", marginBottom: 16 }}>
            Pick a date range, or leave it blank to download the current month's activity.
          </p>
          <Row gutter={12} align="middle">
            <Col>
              <RangePicker value={dateRange} onChange={setDateRange} allowClear />
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                loading={downloading}
                onClick={handleDownload}
                style={{ background: "#00ADEF", borderColor: "#00ADEF" }}
              >
                Download Report
              </Button>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
